"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Downvote = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "m495.51998,229.11477l1.45219,-1.89127c7.32144,-10.98995 -0.60392,-26.21879 -14.64172,-26.21879l-118.09445,0.01997l-0.01229,-183.75463c0,-9.39982 -7.78464,-17.02003 -17.38729,-17.02003l-192.55098,0l-2.35934,0.15545c-8.48685,1.12695 -15.02795,8.24791 -15.02795,16.86458l0.00487,183.75463l-118.23354,-0.01997c-14.86358,0 -22.87448,17.07314 -13.18953,28.11006l231.83048,264.19358c6.93799,7.9066 19.44107,7.9066 26.37906,0l231.83048,-264.19358zm-245.02001,227.00617l-193.97256,-221.05619l97.75804,-0.01997l2.35934,-0.15545c8.48685,-1.12695 15.02795,-8.24791 15.02795,-16.86458l0.00487,-183.72831l157.78382,0l-0.01229,183.72831l0.1588,2.30951c1.15127,8.30759 8.42611,14.71053 17.22848,14.71053l97.65928,0.01997l-193.99574,221.05619z"
}));

var _default = Downvote;
exports.default = _default;